import React, { useContext } from 'react';
import { useBgData } from '@vfpf/vfpf-shared';
import { Framework, } from '@vfpf/framework';
import { initialFormulierState } from './state';
import { formulierProcessCreator } from './process';
import { FormulierDependencies } from './dependencies';

export const FormulierMainContext = Framework.createContext(
  initialFormulierState,
  formulierProcessCreator
);

export const MainService: React.FC<React.PropsWithChildren> = props => {
  const bgData = useBgData();
  const deps: FormulierDependencies = {
    bgData : bgData.bgData,
  }
  const service = Framework.useService(deps, initialFormulierState, formulierProcessCreator);
  return (
    <FormulierMainContext.Provider value={service}>{props.children} </FormulierMainContext.Provider>
  );
}

export const useMainContext = () => {
  const context = useContext(FormulierMainContext);
  if (context === undefined) throw new Error('No Context is provided');
  return context;
};
